import type { Severity } from "../../types/assessment";
export function Badge({
  children,
  tone = "neutral",
}: {
  children: React.ReactNode;
  tone?: Severity | "neutral" | "info";
}) {
  const colors = {
    blocking: "border-red-500/30 bg-red-500/15 text-red-300",
    high: "border-orange-500/30 bg-orange-500/15 text-orange-300",
    medium: "border-amber-500/30 bg-amber-500/15 text-amber-200",
    low: "border-sky-500/30 bg-sky-500/15 text-sky-200",
    passed: "border-emerald-500/30 bg-emerald-500/15 text-emerald-300",
    neutral: "border-slate-600 bg-slate-800 text-slate-300",
    info: "border-cyan-500/30 bg-cyan-500/10 text-cyan-200",
  };
  return (
    <span
      className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${colors[tone]}`}
    >
      {children}
    </span>
  );
}
